import axios from "axios";

export default {
    getAll() {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };
        return axios
            .get("api/productos", headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    getAllForDrop() {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get("api/productos-drop", headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    get(id) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get(`api/producto/${id}`, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    add(producto) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .post("api/producto", producto, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    update(producto) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .put(`api/producto/${producto.productoId}`, producto, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    delete(id) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .delete(`api/producto/${id}`, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    getProductosCatalogoByConjunto(conjuntoId) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get(`api/productos-catalogo/${conjuntoId}`, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    getProductoCatalogo(productoId) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get(`api/producto-catalogo/${productoId}`, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },
};